// Mirror of backend/config/levels.py — single source of truth for XP thresholds.
export const LEVEL_XP_THRESHOLDS = {
  1: 0,
  2: 50,
  3: 150,
  4: 300,
  5: 550,
  6: 950,
  7: 1500,
  8: 2300,
  9: 3300,
  10: 4700,
  11: 6500,
  12: 9000,
  13: 13000,
  14: 18500,
  15: 25500,
};

export const MAX_LEVEL = 15;

export const LEVEL_TITLES = {
  1: 'Moussaillon',
  2: 'Matelot',
  3: 'Matelot Confirmé',
  4: 'Navigateur',
  5: 'Officier',
  6: 'Capitaine',
  7: 'Commandant',
  8: 'Amiral',
  9: 'Vice-Amiral',
  10: 'Grand Amiral',
  11: 'Légende',
  12: 'Maître des Mers',
  13: 'Commodore',
  14: 'Amiral de la Flotte',
  15: 'Empereur des Océans',
};
